/**
 * Single source of truth for the homepage "สั่งงานง่ายใน 4 ขั้นตอน" process.
 * Rendered by HomeSections and mirrored into HowTo JSON-LD so every schema
 * step is backed by visible on-page text (Google HowTo requirement).
 */
export type HomeOrderStep = { n: string; t: string; d: string };

export const HOME_ORDER_STEPS: HomeOrderStep[] = [
  { n: "01", t: "ส่งรูปเอกสารผ่าน LINE", d: "ถ่ายรูปเอกสารต้นฉบับ พร้อมแจ้งประเทศปลายทางและประเภทวีซ่า — เรารับงานทุกวัน 08:00–20:00" },
  { n: "02", t: "รับใบเสนอราคา/ไทม์ไลน์", d: "ทีมประเมินราคา ระยะเวลา และจัดทำ Project Plan ส่งกลับภายใน 30 นาที" },
  { n: "03", t: "แปล • รับรอง • ยื่นแทน", d: "เริ่มแปลทันทีหลังยืนยัน รับเอกสารตัวจริงในภูเก็ต ส่งทีมในกรุงเทพฯ ยื่น MFA และสถานทูต" },
  { n: "04", t: "ส่งเอกสารคืนถึงมือท่าน", d: "ส่งเอกสารชุดสมบูรณ์กลับถึงบ้าน วิลล่า โรงแรม หรือสำนักงานในภูเก็ตด้วยขนส่งติดตาม Tracking" },
];
